module.exports = __webpack_public_path__ + "img/hu1.c406c4ad.png";